import React, { Component } from 'react';
import '../../../../../styles/detail-inspection-body.css';
import Tab from '../../../../shared/tabs';
import Pane from '../../../../shared/tabs/pane';

import '../../../../../styles/inspection.css';
import Pictures from './pictures';
import Accessories from './accessories';
import Damages from './damages';
class InspectionBody extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tabSelected: 0,
            picturescustomer: [],
        }
    }

    handleChangeTab = (index) => this.setState({ tabSelected: index });
    onSelectImage = (index) => {
        alert(index);
    }

    render() {
        const { inspection = {}, changeCommentsDamages, changeCommentsPictures, saveCommentsDamages, saveCommentsPictures } = this.props;
        const { pictures = [], accessories = [], damages = [], picturesObserveds = [] } = inspection;
        const { tabSelected } = this.state;

        return (
            <div className="main-body">
                <Tab onClick={this.handleChangeTab} tabActive={tabSelected}>
                    <Pane label="Características" tabActive={tabSelected} tabPosition={0}>
                        <Pictures images={pictures} inspection={inspection} onChangePictures={changeCommentsPictures} handleSelect={this.props.handleModalObservation} picturesObserveds={picturesObserveds} saveComment={saveCommentsPictures} />
                    </Pane>
                    <Pane label="Accesorios" tabActive={tabSelected} tabPosition={1}>
                        <Accessories images={accessories} inspection={inspection}  handleSelect={this.props.handleModalObservation} picturesObserveds={picturesObserveds} />
                    </Pane>
                    <Pane label="Daños" tabActive={tabSelected} tabPosition={2}>
                        <Damages images={damages} inspection={inspection} onChangeDamage={changeCommentsDamages} saveComment={saveCommentsDamages}  handleSelect={this.props.handleModalObservation} picturesObserveds={picturesObserveds} />
                    </Pane>
                </Tab>
            </div>
        )
    }
}

export default InspectionBody;



// WEBPACK FOOTER //
// ./src/components/app/dashboard/inspection/components/inspection-body.js